import Vue from "vue";
import {Commit, Getter} from "vuex";

/**
 * Store file references for entries here while they are uploading.
 */

interface EntryFilesState {
  fileReferences: { [propName: string]: string[] };
}

interface EntryFilePayload {
  entry_ref: string;
  file_ref: string;
}

const state: EntryFilesState = {
  fileReferences: {}
};

const mutations = {
  add(store: EntryFilesState, payload: EntryFilePayload): void {
    if (!store.fileReferences[payload.entry_ref]) {
      Vue.set(store.fileReferences, payload.entry_ref, []);
    }

    store.fileReferences[payload.entry_ref].push(payload.file_ref);
  },

  remove(store: EntryFilesState, payload: EntryFilePayload): void {
    if (store.fileReferences[payload.entry_ref]) {
      const pos = store.fileReferences[payload.entry_ref].indexOf(payload.file_ref);
      if (pos > -1) {
        store.fileReferences[payload.entry_ref].splice(pos, 1);
      }
    }
  }
};

const actions = {
  add({commit}: {commit: Commit}, payload: EntryFilePayload): void {
    commit('add', payload);
  },

  remove({commit}: {commit: Commit}, payload: EntryFilePayload): void {
    commit('remove', payload);
  }
};

const getters = {
  allFromEntry: (state: EntryFilesState) => (ref: string): string[] => {
    return state.fileReferences[ref] ?? [];
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
